var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auto-cache-page" },
    [
      _c("div", { staticClass: "topbar" }, [
        _c("div", { staticClass: "topbar-left" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "topbar-badge",
              class: _vm.form.autoCacheEnabled ? "on" : "off",
            },
            [
              _c("span", { staticClass: "dot" }),
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.form.autoCacheEnabled ? "功能已启用" : "功能已停用"
                  ) +
                  "\n        "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "topbar-right" },
          [
            _c("div", { staticClass: "topbar-metrics" }, [
              _c("div", { staticClass: "mini-m" }, [
                _c("span", { staticClass: "mini-v" }, [
                  _vm._v(_vm._s(_vm.metricsData.currentQps || 0)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mini-l" }, [_vm._v("QPS")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mini-sep" }),
              _vm._v(" "),
              _c("div", { staticClass: "mini-m" }, [
                _c("span", { staticClass: "mini-v" }, [
                  _vm._v(_vm._s(_vm.metricsData.currentActiveUsers || 0)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mini-l" }, [_vm._v("活跃用户")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mini-sep" }),
              _vm._v(" "),
              _c("div", { staticClass: "mini-m" }, [
                _c(
                  "span",
                  {
                    staticClass: "mini-v mode-tag",
                    class: "mode-" + _vm.form.currentMode,
                  },
                  [_vm._v(_vm._s(_vm.modeShortName))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "mini-l" }, [_vm._v("运行模式")]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "master-btn",
                class: { "btn-on": _vm.form.autoCacheEnabled },
                on: {
                  click: function ($event) {
                    return _vm.onAutoCacheEnabledChange(
                      !_vm.form.autoCacheEnabled
                    )
                  },
                },
              },
              [
                _c("i", {
                  class: _vm.form.autoCacheEnabled
                    ? "el-icon-video-pause"
                    : "el-icon-video-play",
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.form.autoCacheEnabled ? "停用" : "启用") +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "guide-btn",
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    _vm.showGuide = !_vm.showGuide
                  },
                },
              },
              [
                _c("i", {
                  class: _vm.showGuide ? "el-icon-arrow-up" : "el-icon-guide",
                }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.showGuide ? "收起说明" : "使用说明") +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "guide-fade" } }, [
        _vm.showGuide
          ? _c("div", { staticClass: "guide-panel" }, [
              _c("div", { staticClass: "guide-inner" }, [
                _c("div", { staticClass: "guide-row" }, [
                  _c("div", { staticClass: "guide-row-label" }, [
                    _c("i", { staticClass: "el-icon-s-tools" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("运行模式")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "guide-mode-cards" },
                    _vm._l(_vm.modeOptions, function (m) {
                      return _c(
                        "div",
                        {
                          key: m.value,
                          staticClass: "guide-mode-card",
                          class: "mode-" + m.value,
                          on: {
                            click: function ($event) {
                              return _vm.onModeChange(m.value)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "gmc-icon" }, [
                            _c("i", { class: m.icon }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "gmc-info" }, [
                            _c("div", { staticClass: "gmc-name" }, [
                              _vm._v(_vm._s(m.label)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "gmc-desc" }, [
                              _vm._v(_vm._s(m.desc)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.form.currentMode === m.value
                            ? _c("div", { staticClass: "gmc-check" }, [
                                _c("i", { staticClass: "el-icon-check" }),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "guide-row" }, [
                  _c(
                    "div",
                    { staticClass: "guide-row-label" },
                    [
                      _c("i", { staticClass: "el-icon-data-analysis" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("滞回区间")]),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              "开启阈值与关闭阈值之间的缓冲地带，用于避免在临界值附近频繁开关",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              color: "#8c8c8c",
                              cursor: "pointer",
                              "margin-left": "4px",
                              "font-size": "12px",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide-hysteresis" }, [
                    _c("div", { staticClass: "hys-bar-wrap" }, [
                      _c("div", { staticClass: "hys-bar-track" }, [
                        _c("div", { staticClass: "hys-zone hys-zone-off" }, [
                          _c("span", { staticClass: "zone-label" }, [
                            _vm._v("关闭区"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "zone-val" }, [
                            _vm._v(
                              "QPS < " +
                                _vm._s(_vm.thresholdData.qpsOffThreshold)
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hys-zone hys-zone-mid" }, [
                          _c("span", { staticClass: "zone-label" }, [
                            _vm._v("滞回区间"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "zone-val" }, [
                            _vm._v("保持现状"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hys-zone hys-zone-on" }, [
                          _c("span", { staticClass: "zone-label" }, [
                            _vm._v("开启区"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "zone-val" }, [
                            _vm._v(
                              "QPS ≥ " +
                                _vm._s(_vm.thresholdData.qpsOnThreshold)
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "hys-marker",
                        style: { left: _vm.thresholdMarkerPos + "%" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hys-rule" }, [
                      _c("div", { staticClass: "rule-item rule-on" }, [
                        _c("span", { staticClass: "rule-icon" }, [
                          _c("i", { staticClass: "el-icon-top" }),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "开启：QPS ≥ " +
                              _vm._s(_vm.thresholdData.qpsOnThreshold) +
                              " "
                          ),
                          _c("strong", [_vm._v("或")]),
                          _vm._v(
                            " 活跃用户 ≥ " +
                              _vm._s(_vm.thresholdData.userOnThreshold)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rule-item rule-off" }, [
                        _c("span", { staticClass: "rule-icon" }, [
                          _c("i", { staticClass: "el-icon-bottom" }),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "关闭：QPS < " +
                              _vm._s(_vm.thresholdData.qpsOffThreshold) +
                              " "
                          ),
                          _c("strong", [_vm._v("且")]),
                          _vm._v(
                            " 活跃用户 < " +
                              _vm._s(_vm.thresholdData.userOffThreshold)
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "guide-row" }, [
                  _c("div", { staticClass: "guide-row-label" }, [
                    _c("i", { staticClass: "el-icon-warning-outline" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("QPS 与活跃用户的区别")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "guide-diff-cards" }, [
                    _c("div", { staticClass: "diff-card diff-qps" }, [
                      _c("div", { staticClass: "diff-icon" }, [
                        _c("i", { staticClass: "el-icon-data-line" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "diff-body" }, [
                        _c("div", { staticClass: "diff-title" }, [
                          _vm._v("QPS（每秒请求数）"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "diff-desc" }, [
                          _vm._v("衡量"),
                          _c("strong", [_vm._v("瞬时并发压力")]),
                          _vm._v(
                            "的指标。适合大流量场景，如整点抢购、秒杀活动，此时请求数会急剧攀升，开启缓存可有效保护数据库。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "diff-example" }, [
                          _vm._v("典型场景：电商大促、限时活动、热门商品开售"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "diff-card diff-user" }, [
                      _c("div", { staticClass: "diff-icon" }, [
                        _c("i", { staticClass: "el-icon-user-solid" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "diff-body" }, [
                        _c("div", { staticClass: "diff-title" }, [
                          _vm._v("活跃用户数（过去 N 秒内有请求的独立用户）"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "diff-desc" }, [
                          _vm._v("衡量"),
                          _c("strong", [_vm._v("持续在线规模")]),
                          _vm._v(
                            "的指标。适合访问持续较高但 QPS 瞬时值不高的场景，更能反映真实承载压力。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "diff-example" }, [
                          _vm._v(
                            "典型场景：直播带货、在线课程、社区论坛、长时间浏览页面"
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-body" }, [
        _c("div", { staticClass: "col-left" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-bd" }, [
              _c("div", { staticClass: "metric-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "metric-item",
                    class: { warm: _vm.isAboveQpsThreshold },
                  },
                  [
                    _c("div", { staticClass: "metric-item-hd" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "metric-badge",
                          class: _vm.isAboveQpsThreshold
                            ? "badge-warn"
                            : "badge-ok",
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.isAboveQpsThreshold ? "已达阈值" : "正常"
                              ) +
                              "\n                  "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-val" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.metricsData.currentQps || 0) +
                          "\n                  "
                      ),
                      _c("span", { staticClass: "metric-unit" }, [
                        _vm._v("req/s"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-bar-wrap" }, [
                      _c("div", { staticClass: "metric-bar-track" }, [
                        _c("div", {
                          staticClass: "metric-bar-fill",
                          class: { "fill-warm": _vm.isAboveQpsThreshold },
                          style: { width: _vm.qpsPercentage + "%" },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "metric-bar-threshold",
                          style: { left: _vm.qpsThresholdPos + "%" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "metric-bar-legend" }, [
                        _c("span", [_vm._v("0")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "legend-threshold" }, [
                          _vm._v(_vm._s(_vm.thresholdData.qpsOnThreshold)),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              Math.round(_vm.thresholdData.qpsOnThreshold * 1.5)
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "metric-item",
                    class: { warm: _vm.isAboveUserThreshold },
                  },
                  [
                    _c("div", { staticClass: "metric-item-hd" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "metric-badge",
                          class: _vm.isAboveUserThreshold
                            ? "badge-warn"
                            : "badge-ok",
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.isAboveUserThreshold ? "已达阈值" : "正常"
                              ) +
                              "\n                  "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-val" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.metricsData.currentActiveUsers || 0) +
                          "\n                  "
                      ),
                      _c("span", { staticClass: "metric-unit" }, [
                        _vm._v("人"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metric-bar-wrap" }, [
                      _c("div", { staticClass: "metric-bar-track" }, [
                        _c("div", {
                          staticClass: "metric-bar-fill user-fill",
                          class: { "fill-warm": _vm.isAboveUserThreshold },
                          style: { width: _vm.userPercentage + "%" },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "metric-bar-threshold",
                          style: { left: _vm.userThresholdPos + "%" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "metric-bar-legend" }, [
                        _c("span", [_vm._v("0")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "legend-threshold" }, [
                          _vm._v(_vm._s(_vm.thresholdData.userOnThreshold)),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              Math.round(
                                _vm.thresholdData.userOnThreshold * 1.5
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-hd" }, [
              _c(
                "div",
                { staticClass: "card-hd-left" },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content:
                          "建议关闭阈值设为开启阈值的 50%~70%，形成明显的滞回区间",
                        placement: "top",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-question",
                        staticStyle: { color: "#bfbfbf", cursor: "pointer" },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-hd-right" },
                [
                  !_vm.thresholdEditing
                    ? [
                        _c(
                          "el-button",
                          {
                            staticClass: "edit-btn",
                            attrs: { type: "text", size: "small" },
                            on: { click: _vm.onThresholdEdit },
                          },
                          [
                            _c("i", { staticClass: "el-icon-edit-outline" }),
                            _vm._v(" 编辑阈值\n                "),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "el-button",
                          {
                            staticClass: "cancel-btn",
                            attrs: { type: "text", size: "small" },
                            on: { click: _vm.onThresholdCancel },
                          },
                          [_c("i", { staticClass: "el-icon-close" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "save-btn",
                            attrs: {
                              type: "primary",
                              size: "small",
                              loading: _vm.thresholdSaving,
                            },
                            on: { click: _vm.onThresholdSave },
                          },
                          [
                            _c("i", { staticClass: "el-icon-check" }),
                            _vm._v(" 保存\n                "),
                          ]
                        ),
                      ],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-bd" }, [
              _c("div", { staticClass: "threshold-grid" }, [
                _c(
                  "div",
                  { staticClass: "threshold-card thr-on" },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    !_vm.thresholdEditing
                      ? _c("div", { staticClass: "thr-num" }, [
                          _vm._v(_vm._s(_vm.thresholdData.qpsOnThreshold)),
                        ])
                      : _c("el-input-number", {
                          staticClass: "thr-input",
                          attrs: { min: 1, max: 99999, size: "small" },
                          model: {
                            value: _vm.thresholdEdit.qpsOnThreshold,
                            callback: function ($$v) {
                              _vm.$set(_vm.thresholdEdit, "qpsOnThreshold", $$v)
                            },
                            expression: "thresholdEdit.qpsOnThreshold",
                          },
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "thr-hint" }, [
                      _vm._v("达到此值自动开启缓存"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "threshold-card thr-off" },
                  [
                    _vm._m(6),
                    _vm._v(" "),
                    !_vm.thresholdEditing
                      ? _c("div", { staticClass: "thr-num" }, [
                          _vm._v(_vm._s(_vm.thresholdData.qpsOffThreshold)),
                        ])
                      : _c("el-input-number", {
                          staticClass: "thr-input",
                          attrs: { min: 1, max: 99999, size: "small" },
                          model: {
                            value: _vm.thresholdEdit.qpsOffThreshold,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.thresholdEdit,
                                "qpsOffThreshold",
                                $$v
                              )
                            },
                            expression: "thresholdEdit.qpsOffThreshold",
                          },
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "thr-hint" }, [
                      _vm._v("低于此值自动关闭缓存"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "threshold-card thr-on" },
                  [
                    _vm._m(7),
                    _vm._v(" "),
                    !_vm.thresholdEditing
                      ? _c("div", { staticClass: "thr-num" }, [
                          _vm._v(_vm._s(_vm.thresholdData.userOnThreshold)),
                        ])
                      : _c("el-input-number", {
                          staticClass: "thr-input",
                          attrs: { min: 1, max: 99999, size: "small" },
                          model: {
                            value: _vm.thresholdEdit.userOnThreshold,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.thresholdEdit,
                                "userOnThreshold",
                                $$v
                              )
                            },
                            expression: "thresholdEdit.userOnThreshold",
                          },
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "thr-hint" }, [
                      _vm._v("达到此用户数自动开启缓存"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "threshold-card thr-off" },
                  [
                    _vm._m(8),
                    _vm._v(" "),
                    !_vm.thresholdEditing
                      ? _c("div", { staticClass: "thr-num" }, [
                          _vm._v(_vm._s(_vm.thresholdData.userOffThreshold)),
                        ])
                      : _c("el-input-number", {
                          staticClass: "thr-input",
                          attrs: { min: 1, max: 99999, size: "small" },
                          model: {
                            value: _vm.thresholdEdit.userOffThreshold,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.thresholdEdit,
                                "userOffThreshold",
                                $$v
                              )
                            },
                            expression: "thresholdEdit.userOffThreshold",
                          },
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "thr-hint" }, [
                      _vm._v("低于此用户数自动关闭缓存"),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-right" }, [
          _c("div", { staticClass: "card mode-card" }, [
            _vm._m(9),
            _vm._v(" "),
            _c("div", { staticClass: "card-bd" }, [
              _c(
                "div",
                { staticClass: "mode-list" },
                _vm._l(_vm.modeOptions, function (m) {
                  var _obj
                  return _c(
                    "div",
                    {
                      key: m.value,
                      staticClass: "mode-item",
                      class:
                        ((_obj = { active: _vm.form.currentMode === m.value }),
                        (_obj["mode-" + m.value] = true),
                        _obj),
                      on: {
                        click: function ($event) {
                          return _vm.onModeChange(m.value)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "mode-item-icon" }, [
                        _c("i", { class: m.icon }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mode-item-body" }, [
                        _c("div", { staticClass: "mode-item-name" }, [
                          _vm._v(_vm._s(m.label)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mode-item-desc" }, [
                          _vm._v(_vm._s(m.desc)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.form.currentMode === m.value
                        ? _c("div", { staticClass: "mode-item-check" }, [
                            _c("i", { staticClass: "el-icon-check" }),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(10),
            _vm._v(" "),
            _c("div", { staticClass: "card-bd" }, [
              _c(
                "div",
                { staticClass: "quick-btns" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "quick-btn",
                      attrs: {
                        size: "small",
                        type: "success",
                        plain: "",
                        disabled: _vm.form.currentMode === "auto",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onQuickAction("open-all")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "qbtn-icon" }, [
                        _c("i", { staticClass: "el-icon-unlock" }),
                      ]),
                      _vm._v("全部开启\n              "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "quick-btn",
                      attrs: {
                        size: "small",
                        type: "danger",
                        plain: "",
                        disabled: _vm.form.currentMode === "auto",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onQuickAction("close-all")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "qbtn-icon" }, [
                        _c("i", { staticClass: "el-icon-lock" }),
                      ]),
                      _vm._v("全部关闭\n              "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "quick-btn",
                      attrs: {
                        size: "small",
                        type: "warning",
                        plain: "",
                        disabled: !_vm.hasAnyLocked,
                        loading: _vm.unlockAllLoading,
                      },
                      on: { click: _vm.unlockAll },
                    },
                    [
                      _c("span", { staticClass: "qbtn-icon" }, [
                        _c("i", { staticClass: "el-icon-unlock" }),
                      ]),
                      _vm._v("解除所有锁定\n              "),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.currentMode === "auto"
                ? _c("div", { staticClass: "quick-tip" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _vm._v(" 自动模式下，快捷操作已禁用\n            "),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card switch-card" }, [
        _c(
          "div",
          { staticClass: "card-hd" },
          [
            _vm._m(11),
            _vm._v(" "),
            _c("span", { staticClass: "card-sub" }, [
              _vm._v("手动设置将在混合模式下触发 30 天锁定"),
            ]),
            _vm._v(" "),
            _c("span", { staticStyle: { flex: "1" } }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "text",
                  size: "small",
                  loading: _vm.tableLoading,
                },
                on: { click: _vm.refresh },
              },
              [
                _c("i", { staticClass: "el-icon-refresh" }),
                _vm._v(" 刷新\n        "),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small", plain: "" },
                on: { click: _vm.openAddSwitchDialog },
              },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _vm._v(" 新增开关\n        "),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-bd no-pad" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                attrs: {
                  data: _vm.switchList,
                  size: "small",
                  "header-cell-style": {
                    fontWeight: "bold",
                    background: "#fafafa",
                  },
                  "row-class-name": _vm.getSwitchRowClassName,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "缓存开关", "min-width": "160" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "sw-cell" }, [
                            _c(
                              "div",
                              {
                                staticClass: "sw-icon",
                                class:
                                  scope.row.state === "1" ? "sw-on" : "sw-off",
                              },
                              [
                                _c("i", {
                                  class:
                                    scope.row.state === "1"
                                      ? "el-icon-circle-check"
                                      : "el-icon-circle-close",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "sw-info" }, [
                              _c("span", { staticClass: "sw-desc" }, [
                                _vm._v(_vm._s(scope.row.name)),
                              ]),
                              _vm._v(" "),
                              _c("code", { staticClass: "sw-key" }, [
                                _vm._v(_vm._s(scope.row.configKey)),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", width: "90", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "sw-state",
                              class:
                                scope.row.state === "1"
                                  ? "state-on"
                                  : "state-off",
                            },
                            [
                              _c("span", { staticClass: "sw-dot" }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    scope.row.state === "1"
                                      ? "已开启"
                                      : "已关闭"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "锁定", width: "80", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              staticClass: "lock-tag",
                              attrs: {
                                type: scope.row.manuallyLocked
                                  ? "warning"
                                  : "info",
                                size: "small",
                                effect: "plain",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    scope.row.manuallyLocked
                                      ? "已锁定"
                                      : "未锁定"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "150", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "op-cell" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "op-btn-primary",
                                  attrs: {
                                    type:
                                      scope.row.state === "1"
                                        ? "danger"
                                        : "success",
                                    size: "mini",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSwitchChange(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class:
                                      scope.row.state === "1"
                                        ? "el-icon-close"
                                        : "el-icon-check",
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        scope.row.state === "1"
                                          ? "关闭"
                                          : "开启"
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dropdown",
                                {
                                  attrs: {
                                    trigger: "click",
                                    placement: "bottom-end",
                                  },
                                  on: {
                                    command: function (cmd) {
                                      return _vm.handleSwitchCommand(
                                        cmd,
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "op-more-btn",
                                      attrs: { size: "mini" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "op-more-text" },
                                        [_vm._v("更多")]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "edit",
                                            disabled: false,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit-outline",
                                          }),
                                          _vm._v(" 编辑\n                    "),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          staticStyle: { color: "#ff4d4f" },
                                          attrs: { command: "delete" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                          _vm._v(" 删除\n                    "),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      scope.row.manuallyLocked
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              staticStyle: { color: "#fa8c16" },
                                              attrs: { command: "unlock" },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-unlock",
                                              }),
                                              _vm._v(
                                                " 解除锁定\n                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card log-card" }, [
        _c(
          "div",
          { staticClass: "card-hd" },
          [
            _vm._m(12),
            _vm._v(" "),
            _c("span", { staticClass: "card-sub" }, [
              _vm._v("最近 " + _vm._s((_vm.logList || []).length) + " 条"),
            ]),
            _vm._v(" "),
            _c("span", { staticStyle: { flex: "1" } }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "text", size: "small", loading: _vm.logLoading },
                on: { click: _vm.refresh },
              },
              [
                _c("i", { staticClass: "el-icon-refresh" }),
                _vm._v(" 刷新\n        "),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-bd no-pad" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.logLoading,
                    expression: "logLoading",
                  },
                ],
                attrs: {
                  data: _vm.logList,
                  size: "small",
                  "max-height": "280",
                  "header-cell-style": {
                    fontWeight: "bold",
                    background: "#fafafa",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "时间", width: "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "log-time" }, [
                            _vm._v(_vm._s(_vm.formatTime(scope.row.timestamp))),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "开关", "min-width": "140" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "log-name" }, [
                            _vm._v(
                              _vm._s(_vm.getSwitchName(scope.row.cacheKey))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "变化", width: "120", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "log-change" }, [
                            _c(
                              "span",
                              {
                                staticClass: "log-badge",
                                class:
                                  scope.row.fromState === "1"
                                    ? "b-on"
                                    : scope.row.fromState == null
                                    ? "b-none"
                                    : "b-off",
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      scope.row.fromState === "1"
                                        ? "开"
                                        : scope.row.fromState == null
                                        ? "-"
                                        : "关"
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "el-icon-arrow-right",
                              staticStyle: {
                                color: "#d9d9d9",
                                "font-size": "11px",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "log-badge",
                                class:
                                  scope.row.toState === "1" ? "b-on" : "b-off",
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      scope.row.toState === "1" ? "开" : "关"
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "触发原因", "min-width": "240" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: scope.row.reason,
                                placement: "top",
                                "open-delay": 300,
                              },
                            },
                            [
                              _c("span", { staticClass: "log-reason" }, [
                                _vm._v(_vm._s(scope.row.reason)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "指标", width: "140", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "log-pills" }, [
                            _c("span", { staticClass: "p-pill" }, [
                              _vm._v("QPS " + _vm._s(scope.row.qps || "-")),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-pill" }, [
                              _vm._v(
                                "用户 " + _vm._s(scope.row.activeUsers || "-")
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "模式", width: "80", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              staticClass: "mode-tag-mini",
                              attrs: {
                                size: "mini",
                                type: _vm.modeTagType(scope.row.mode),
                                effect: "plain",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.modeName(scope.row.mode)) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.logList || _vm.logList.length === 0
              ? _c("div", { staticClass: "log-empty" }, [
                  _c("i", { staticClass: "el-icon-chat-line-square" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无切换记录")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "log-empty-sub" }, [
                    _vm._v("开启自动模式或手动操作后，将在此显示历史记录"),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.switchDialogTitle,
            visible: _vm.switchDialog,
            width: "520px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.switchDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "switchFormRef",
              attrs: {
                model: _vm.switchForm,
                rules: _vm.switchFormRules,
                "label-width": "100px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.switchDialogTitle === "新增缓存开关"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "开关标识", prop: "configKey" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "如 user_list_cache_switch",
                          maxlength: "50",
                          "show-word-limit": "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.switchForm.configKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.switchForm, "configKey", $$v)
                          },
                          expression: "switchForm.configKey",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-tip-text" }, [
                        _vm._v("小写英文、数字、下划线，以英文开头，3-50字符"),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    { attrs: { label: "开关标识" } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm.switchForm.configKey,
                          disabled: "",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "开关名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "如 用户列表缓存开关",
                      maxlength: "100",
                      "show-word-limit": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.switchForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.switchForm, "name", $$v)
                      },
                      expression: "switchForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序号" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 999, "controls-position": "right" },
                    model: {
                      value: _vm.switchForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.switchForm, "sort", $$v)
                      },
                      expression: "switchForm.sort",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip-text" }, [
                    _vm._v("数字越小越靠前，默认99"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注说明" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "选填，备注说明",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.switchForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.switchForm, "remark", $$v)
                      },
                      expression: "switchForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.switchDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.switchDialogLoading },
                  on: { click: _vm.onSaveSwitch },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "topbar-title" }, [
      _c("i", { staticClass: "el-icon-box" }),
      _vm._v(" "),
      _c("span", [_vm._v("自动缓存开关")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-hd" }, [
      _c("div", { staticClass: "card-hd-left" }, [
        _c("span", { staticClass: "card-title" }, [
          _c("i", { staticClass: "el-icon-odometer" }),
          _vm._v(" 实时并发指标"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "card-sub" }, [_vm._v("每 10 秒自动刷新")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-hd-right" }, [
        _c("span", { staticClass: "live-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "live-label" }, [_vm._v("LIVE")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "metric-label-row" }, [
      _c("span", { staticClass: "metric-icon-wrap qps-icon" }, [
        _c("i", { staticClass: "el-icon-data-line" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "metric-label" }, [_vm._v("当前 QPS")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "metric-label-row" }, [
      _c("span", { staticClass: "metric-icon-wrap user-icon" }, [
        _c("i", { staticClass: "el-icon-user-solid" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "metric-label" }, [_vm._v("活跃用户数")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "card-title" }, [
      _c("i", { staticClass: "el-icon-setting" }),
      _vm._v(" 阈值配置"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "thr-top" }, [
      _c("span", { staticClass: "thr-arrow" }, [
        _c("i", { staticClass: "el-icon-top" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "thr-name" }, [_vm._v("QPS 开启阈值")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "thr-top" }, [
      _c("span", { staticClass: "thr-arrow" }, [
        _c("i", { staticClass: "el-icon-bottom" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "thr-name" }, [_vm._v("QPS 关闭阈值")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "thr-top" }, [
      _c("span", { staticClass: "thr-arrow" }, [
        _c("i", { staticClass: "el-icon-top" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "thr-name" }, [_vm._v("用户 开启阈值")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "thr-top" }, [
      _c("span", { staticClass: "thr-arrow" }, [
        _c("i", { staticClass: "el-icon-bottom" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "thr-name" }, [_vm._v("用户 关闭阈值")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-hd" }, [
      _c("span", { staticClass: "card-title" }, [
        _c("i", { staticClass: "el-icon-magic-stick" }),
        _vm._v(" 运行模式"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-hd" }, [
      _c("span", { staticClass: "card-title" }, [
        _c("i", { staticClass: "el-icon-lightning" }),
        _vm._v(" 快捷操作"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "card-title" }, [
      _c("i", { staticClass: "el-icon-grid" }),
      _vm._v(" 缓存开关状态"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "card-title" }, [
      _c("i", { staticClass: "el-icon-notebook-2" }),
      _vm._v(" 切换日志"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }